'use strict';

var cov_1pdlzsg6nj = function () {
  var path = '/codebuild/output/src396452290/src/apps/tnwi/temp/ui/Dialog/lib/Dialog.js',
      hash = 'c80be64452c86f1f007e122d59ec8eee45a9ad44',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src396452290/src/apps/tnwi/temp/ui/Dialog/lib/Dialog.js',
    statementMap: {
      '0': {
        start: {
          line: 5,
          column: 18
        },
        end: {
          line: 12,
          column: 1
        }
      },
      '1': {
        start: {
          line: 14,
          column: 17
        },
        end: {
          line: 21,
          column: 1
        }
      },
      '2': {
        start: {
          line: 16,
          column: 22
        },
        end: {
          line: 16,
          column: 34
        }
      },
      '3': {
        start: {
          line: 20,
          column: 23
        },
        end: {
          line: 20,
          column: 58
        }
      },
      '4': {
        start: {
          line: 23,
          column: 23
        },
        end: {
          line: 28,
          column: 1
        }
      },
      '5': {
        start: {
          line: 27,
          column: 22
        },
        end: {
          line: 27,
          column: 34
        }
      },
      '6': {
        start: {
          line: 30,
          column: 29
        },
        end: {
          line: 34,
          column: 1
        }
      },
      '7': {
        start: {
          line: 36,
          column: 27
        },
        end: {
          line: 46,
          column: 1
        }
      },
      '8': {
        start: {
          line: 48,
          column: 15
        },
        end: {
          line: 64,
          column: 1
        }
      },
      '9': {
        start: {
          line: 49,
          column: 2
        },
        end: {
          line: 62,
          column: 3
        }
      },
      '10': {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 61,
          column: 6
        }
      },
      '11': {
        start: {
          line: 63,
          column: 2
        },
        end: {
          line: 63,
          column: 14
        }
      },
      '12': {
        start: {
          line: 66,
          column: 0
        },
        end: {
          line: 73,
          column: 2
        }
      },
      '13': {
        start: {
          line: 75,
          column: 0
        },
        end: {
          line: 79,
          column: 2
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 16,
            column: 13
          },
          end: {
            line: 16,
            column: 14
          }
        },
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 34
          }
        },
        line: 16
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 20,
            column: 13
          },
          end: {
            line: 20,
            column: 14
          }
        },
        loc: {
          start: {
            line: 20,
            column: 23
          },
          end: {
            line: 20,
            column: 58
          }
        },
        line: 20
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 27,
            column: 13
          },
          end: {
            line: 27,
            column: 14
          }
        },
        loc: {
          start: {
            line: 27,
            column: 22
          },
          end: {
            line: 27,
            column: 34
          }
        },
        line: 27
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 48,
            column: 15
          },
          end: {
            line: 48,
            column: 16
          }
        },
        loc: {
          start: {
            line: 48,
            column: 61
          },
          end: {
            line: 64,
            column: 1
          }
        },
        line: 48
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 20,
            column: 23
          },
          end: {
            line: 20,
            column: 58
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 20,
            column: 39
          },
          end: {
            line: 20,
            column: 52
          }
        }, {
          start: {
            line: 20,
            column: 55
          },
          end: {
            line: 20,
            column: 58
          }
        }],
        line: 20
      },
      '1': {
        loc: {
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 62,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 62,
            column: 3
          }
        }, {
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 62,
            column: 3
          }
        }],
        line: 49
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  z-index: ', ';\n  width: 100%;\n  height: 100%;\n  background: white;\n  opacity: ', ';\n'], ['\n  position: absolute;\n  z-index: ', ';\n  width: 100%;\n  height: 100%;\n  background: white;\n  opacity: ', ';\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: ', ';\n'], ['\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: ', ';\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  display: inline-block;\n  vertical-align: middle;\n  text-align: initial;\n'], ['\n  display: inline-block;\n  vertical-align: middle;\n  text-align: initial;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  margin: 0 auto;\n  height: 100%;\n  text-align: center;\n  &::before {\n    content: \' \';\n    display: inline-block;\n    height: 100%;\n    vertical-align: middle;\n  }\n'], ['\n  margin: 0 auto;\n  height: 100%;\n  text-align: center;\n  &::before {\n    content: \' \';\n    display: inline-block;\n    height: 100%;\n    vertical-align: middle;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Container = (cov_1pdlzsg6nj.s[0]++, _styledComponents2.default.div(_templateObject));

var Backdrop = (cov_1pdlzsg6nj.s[1]++, _styledComponents2.default.div(_templateObject2, function (props) {
  cov_1pdlzsg6nj.f[0]++;
  cov_1pdlzsg6nj.s[2]++;
  return props.zIndex;
}, function (props) {
  cov_1pdlzsg6nj.f[1]++;
  cov_1pdlzsg6nj.s[3]++;
  return props.opacity ? (cov_1pdlzsg6nj.b[0][0]++, props.opacity) : (cov_1pdlzsg6nj.b[0][1]++, 0.9);
}));

var ContentWrapper = (cov_1pdlzsg6nj.s[4]++, _styledComponents2.default.div(_templateObject3, function (props) {
  cov_1pdlzsg6nj.f[2]++;
  cov_1pdlzsg6nj.s[5]++;
  return props.zIndex;
}));

var VerticalAlignWrapper = (cov_1pdlzsg6nj.s[6]++, _styledComponents2.default.div(_templateObject4));

var CenterAlignWrapper = (cov_1pdlzsg6nj.s[7]++, _styledComponents2.default.div(_templateObject5));

cov_1pdlzsg6nj.s[8]++;
var Dialog = function Dialog(_ref) {
  var open = _ref.open,
      children = _ref.children,
      backdrop = _ref.backdrop,
      zIndexBase = _ref.zIndexBase;
  cov_1pdlzsg6nj.f[3]++;
  cov_1pdlzsg6nj.s[9]++;

  if (open) {
    cov_1pdlzsg6nj.b[1][0]++;
    cov_1pdlzsg6nj.s[10]++;

    return _react2.default.createElement(
      Container,
      { className: 'g-Dialog' },
      _react2.default.createElement(Backdrop, (0, _extends3.default)({ className: 'g-Dialog__backdrop' }, backdrop, { zIndex: zIndexBase })),
      _react2.default.createElement(
        ContentWrapper,
        { zIndex: zIndexBase + 1 },
        _react2.default.createElement(
          CenterAlignWrapper,
          null,
          _react2.default.createElement(
            VerticalAlignWrapper,
            { className: 'g-Dialog__content-container' },
            children
          )
        )
      )
    );
  } else {
    cov_1pdlzsg6nj.b[1][1]++;
  }
  cov_1pdlzsg6nj.s[11]++;
  return null;
};

cov_1pdlzsg6nj.s[12]++;
Dialog.propTypes = {
  open: _propTypes2.default.bool,
  children: _propTypes2.default.node.isRequired,
  zIndexBase: _propTypes2.default.number,
  backdrop: _propTypes2.default.shape({
    opacity: _propTypes2.default.number
  })
};

cov_1pdlzsg6nj.s[13]++;
Dialog.defaultProps = {
  open: false,
  zIndexBase: 100,
  backdrop: {}
};

exports.default = Dialog;